import { useQuery } from "@tanstack/react-query";
import { 
  getPlatformDisplayNames, 
  getPlatformLogos, 
  getPlatformOrder 
} from "../lib/api";
import { initializePlatformConstants } from "../lib/report-utils";
import { useEffect } from "react";

/**
 * Hook to fetch and cache platform constants
 * This should be used at the app or report level to ensure constants are available
 */
export function usePlatformConstants() {
  const { data: displayNames, isLoading: isLoadingDisplayNames } = useQuery({
    queryKey: ["platform-display-names"],
    queryFn: getPlatformDisplayNames,
    staleTime: Infinity, // These don't change, cache forever
    gcTime: Infinity,
  });

  const { data: logos, isLoading: isLoadingLogos } = useQuery({
    queryKey: ["platform-logos"],
    queryFn: getPlatformLogos,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  const { data: order, isLoading: isLoadingOrder } = useQuery({
    queryKey: ["platform-order"],
    queryFn: getPlatformOrder,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  // Initialize the cache when all data is loaded
  useEffect(() => {
    if (displayNames && logos && order) {
      initializePlatformConstants(displayNames, logos, order);
    }
  }, [displayNames, logos, order]);

  return {
    isLoading: isLoadingDisplayNames || isLoadingLogos || isLoadingOrder,
    isReady: !!(displayNames && logos && order),
  };
}

